import Airline from '@/views/airline/Airline.vue'

const router = {
    path: '/airline',
    name: 'Airline',
    component: Airline,
    meta: {
        title: 'Airline'
    }
  };

export default router
